import React from 'react'
import Footer from './footer';

export default function About() {
    const mainStyle = {
        maxWidth: '800px',
        margin: '20px auto',
        padding: '20px',
        backgroundColor: '#fff',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
    };

    const sectionStyle = {
        marginBottom: '30px',
    };

    const teamMemberStyle = {
        marginBottom: '20px',
    };
    return (
        <>
            <div className="container">
                <h1 style={{ textAlign: 'center', fontFamily: 'Times New Roman' }}>Web Blog</h1>
                <p style={{ textAlign: 'center' }}>Your go-to destination for all things web development</p>
                <main style={mainStyle}>
                    <section style={sectionStyle}>
                        <h2>Our Mission</h2>
                        <p>Our mission is to simplify the complexities of web development and make it accessible to everyone.</p>
                    </section>
                    <section style={sectionStyle}>
                        <h2>What We Offer</h2>
                        <p>Explore in-depth articles, tutorials, and guides that cover a wide range of topics in web development. From HTML and CSS to JavaScript frameworks and beyond, we break down complex concepts into digestible, actionable insights.</p>
                    </section>
                    <section style={sectionStyle}>
                        <h2>Meet the Team</h2>
                        <br />
                        <div style={teamMemberStyle}>
                            <h3>Rupam Mandal</h3>
                            <p>Founder and Developer</p>
                            <p>I am a 13 year old Full stack developer. I started this blog to share my experiences, knowledge, and love for coding.</p>
                        </div>
                    </section>
                </main>
                <div className="btn-x">
                    <a href="/">
                        <button className='btn btn-primary'>Home</button>
                    </a>
                </div>
            </div>
            <br />
            <Footer />
        </>
    )
}